import {
  sampleSnapshot,
  sampleSuggestions,
  incomeStatement,
  balanceSheet,
  cashFlow,
  sampleOverview,
} from "./mockData";

import { API_BASE_URL } from "./config";

const API_URL = API_BASE_URL;

async function request(path, { method = "GET", body, token } = {}, fallback) {
  try {
    if (path.includes("/ai/insights")) {
      console.log(`[API] Requesting ${path}. Token exists? ${!!token}. Token start: ${token ? token.substring(0, 10) : 'None'}`);
    }
    const res = await fetch(`${API_URL}${path}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    return await res.json();
  } catch (err) {
    console.warn("API fallback in use:", err.message);
    return fallback;
  }
}

export async function registerUser(payload) {
  return request("/auth/register", { method: "POST", body: payload }, null);
}

export async function loginUser(payload) {
  return request("/auth/login", { method: "POST", body: payload }, null);
}

export async function suggestCompanies(query) {
  return request("/search/suggest", { method: "POST", body: { query } }, sampleSuggestions);
}

export async function fetchDashboard(ticker) {
  const data = await request(
    `/dashboard/${ticker}`,
    {},
    {
      snapshot: sampleSnapshot,
      overview: sampleOverview,
      income: incomeStatement,
      balance: balanceSheet,
      cash: cashFlow,
    }
  );
  return {
    snapshot: data.snapshot || sampleSnapshot,
    overview: data.overview || sampleOverview,
    income: data.income || incomeStatement,
  };
}

export async function fetchBalanceSheet(ticker) {
  const data = await request(`/financials/${ticker}/balance`, {}, balanceSheet);
  return data || balanceSheet;
}

export async function fetchCashFlow(ticker) {
  const data = await request(`/financials/${ticker}/cash`, {}, cashFlow);
  return data || cashFlow;
}

export async function fetchAIInsights(payload, token) {
  return request(
    "/ai/insights",
    { method: "POST", body: payload, token },
    {
      ticker: payload.ticker,
      answer: "Revenue is growing steadily; watch margin compression from higher R&D.",
      reasoning: "Local mock reasoning",
      generated_at: new Date().toISOString(),
    }
  );
}

export async function fetchRecentSearches() {
  return request("/recent", {}, []);
}
